export default "__VITE_ASSET__DCEDSExY__"